import React from "react";
import "../../Assets/Styles/Style.css";
const InvestmentInfo = ({ data }) => (
  <>
    <div className="group-info-row">
      <div className="info-label">Investment No</div>
      <div className="info-value-below">{data.investment_info.investment_id}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Total Owe</div>
      <div className="info-value-below">₹{data.investment_info.total_owe}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Total Invested</div>
      <div className="info-value-below">₹{data.investment_info.total_invested}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Total Penalty</div>
      <div className="info-value-below">₹{data.investment_info.total_penalty}</div>
    </div>
    <div className="group-info-row">
      <div className="info-label">Total Penalty Owe</div>
      <div className="info-value-below">₹{data.investment_info.total_penalty_owe}</div>
    </div>
  </>
);

export default InvestmentInfo;
